'use strict';

import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;



// WEBPACK FOOTER //
// ./scripts/routes/admin/partials/jquery-global.js